<template>
  <div>
    <h2 v-if="obData.messages" class="def-header-2 container">
      {{ obData.messages.title }}
    </h2>
    <div class="container">
      <div class="page-blog__items">
        <JewelryCard v-for="item in obData.items" :key="item.id" :result="item" />
      </div>
      <Pagination :result="obData.pagination" @change="getPage" @addMore="addMore" />
    </div>
  </div>
</template>

<script>
import JewelryCard from '@components/card/JewelryCard/JewelryCard.vue';
import Pagination from '@components/bootstrap/Pagination.vue';

export default {
  name: 'PageHolidays',
  components: { Pagination, JewelryCard },
  props: {
    result: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      obData: this.result,
    };
  },
  mounted() {
    // console.log(this.result)
  },
  methods: {
    /**
     * Тут происходит склеивание данных успешного ответа Ajax запроса
     */
    compareResponse(response) {
      const data = response.data.catalogSectionList;

      if (this.debug) {
        console.log('ajaxResponse', response);
      }

      for (const key in data.items) {
        this.obData.catalogSectionList.items.push(data.items[key]);
      }

      this.obData.catalogSectionList.pagination = data.pagination;
    },
    /**
     * Имитация перехода на нужную страницу
     */
    replaceResponse(response) {
      this.obData = response.data;
    },
    /**
     * Метод по которому происходит Ajax загрузка данных (добавление)
     */
    addMore() {
      if (this.obData.pagination.pageCount > this.obData.pagination.pageNumber) {
        axios
          .get(window.location.href, {
            params: {
              api: 'y',
              [this.obData.pagination.pagingKey]: ++this.obData.pagination.pageNumber,
            },
          })
          .then(this.compareResponse)
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
            console.log('always executed');
          });
      }
    },
    /**
     * Метод по которому происходит Ajax переход на нужную страницу
     * @param numb
     */
    getPage(url) {
      axios
        .get(url, {
          params: {
            api: 'y',
          },
        })
        .then(this.replaceResponse)
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
.page-blog-filter {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  overflow-x: auto;
  padding-left: 15px;
  padding-bottom: 15px;
  @include point-md {
    margin-bottom: 32px;
    padding: 0 15px 15px;
    justify-content: center;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background: rgba(184, 217, 236, 0.4);
    border-radius: 20px;
    font-weight: 500;
    font-size: rem(12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    flex-shrink: 0;
    &:not(:last-child) {
      margin-right: 8px;
    }
    &:hover {
      cursor: pointer;
    }
    &_atcive {
      color: #fff;
      background-color: var(--border-colour-primary);
    }
    input {
      display: none;
    }
  }
}
body .jewelry-card__name {
  margin-bottom: 0;
}
.page-blog {
  margin-bottom: 56px;
  margin-top: 16px;
  @include point-md {
    margin-bottom: 80px;
  }
  &__items {
    display: grid;
    grid-gap: 16px 0;
    @include point-md {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 24px;
    }
    @include point-lg {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 40px;
    }
  }
  .pagination {
    padding: 40px 0 0;
    @include point-md {
      padding: 56px 0 0;
    }
    @include point-lg {
      padding: 0;
    }
  }
  .jewelry-card {
    height: auto;
  }
}
</style>
